import useRebrandVersion from 'hooks/useRebrandVersion'

type DividerKind = 'primary' | 'secondary'

/**
 * Kind for the section dividers inside the offer/place detail drawers.
 *
 * Secondary dividers are filled with Light Surface, which under rebrand is also
 * the drawer's own background, leaving them all but invisible. Primary uses
 * Light Foreground and actually separates the sections.
 */
function useDrawerDividerKind(): DividerKind {
  return useRebrandVersion() === 'rebrand' ? 'primary' : 'secondary'
}

export default useDrawerDividerKind
